import React from 'react';

import { flagStyles } from '../settings';

const SvgCN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1104px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCN;
